/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

export const PopularCoursesFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  PopularCourses: gql`
    fragment PopularCoursesQuery on popularCourses_Entry {
      typeHandle
      sectionTitle
      defaultState
      styles
      stateCourseMappings {
        ... on stateCourseMappingsBlock_Entry {
          stateAbbr
          courseOne {
            title
            ...ProductEntry
          }
          courseOneCardTitle {
            html
          }
          courseOneCtaLink
          courseTwo {
            title
            ...ProductEntry
          }
          courseTwoCardTitle {
            html
          }
          courseTwoCtaLink
          viewAllCoursesCtaLink
        }
      }
    }
    ${ProductFragment.product}
  `,
};
